<template>

  <modal id="detalhes-indicador-real" class="modal-detalhes-entidade" :titulo="titulo" :loading="loading" :check="indicadorValido">
    <template #title-extra>
      <div v-if="ficha && deveExibirBadgeStatus" class="badge text-center" :class="classStatus">
        {{statusExibido}}
      </div>
    </template>
    <template #actions>

      <template v-if="!$root.isAuditorOnly && ficha.status !== 'PENDENTE' && !preview">

        <li class="list-inline-item" :class="{active : aba == 'anexos'}" >
          <a @click.prevent="aba = 'anexos'" title="Documentação & Anexos" href>
            <i class="fal fa-paperclip"></i>
          </a>
        </li>

        <li class="list-inline-item" :class="{active : aba == 'historico'}" >
          <a @click.prevent="aba = 'historico'" title="Histórico" href>
            <i class="fas fa-history"></i>
          </a>
        </li>

        <li class="list-inline-item" :class="{active : aba == 'versoes'}">
          <a @click.prevent="aba = 'versoes'" title="Dados anteriores" href>
            <i class="fal fa-user-tag"></i>
          </a>
        </li>

      </template>

        <li class="list-inline-item">
          <router-link :to="{ name: 'digitalizacao', params: { id: id, entidade : 'INDICADOR_REAL', tipoEntidade : getTipoEntidade(ficha) }}" target="_blank" title="Digitalização">
            <i class="fal fa-file-image"></i>
          </router-link>
        </li>

      <li class="list-inline-item" v-if="permitirImprimir">
        <a @click.prevent.stop="imprimir(ficha)" title="Imprimir" href>
          <i class="fal fa-print"></i>
        </a>
      </li>

      <li class="list-inline-item" v-if="(!$root.isAuditorOnly && !preview)">
        <a @click.prevent.stop="editarIndicador(ficha)" title="Editar Indicador"  href>
          <i class="fal fa-edit"></i>
        </a>
      </li>

      <li class="list-inline-item" v-if="(!$root.isAuditorOnly && !preview)">
        <a @click.prevent.stop="importarIndicador(ficha)" title="Importar Indicador"  href>
          <i class="fal fa-file-import"></i>
        </a>
      </li>

      <li class="list-inline-item" v-if="mostrarIa">
        <a @click.prevent.stop="odinMatricula(ficha)" title="Odin - Processar Matrícula" href>
          <i class="fal fa-microchip-ai"></i>
        </a>
      </li>

    </template>

    <template #header>

      <ul class="nav nav-tabs">

        <template  v-for="a in abas">
          <li class="nav-item" :key="a.id" v-if="a.exibir">
            <a @click.prevent="aba = a.id" :title="a.title" class="nav-link py-1 px-2 small"
               href :class="{'active' : aba == a.id}">
              {{a.nome}}
            </a>
          </li>
        </template>

      </ul>

    </template>

    <template v-if="ficha.id">

      <template v-if="!$root.isAuditorOnly">

        <alert-indisponibilidade :imovel="ficha.id" tipo="alert-banner" />
        <alert-ocorrencia :imovel="ficha.id" tipo="alert-banner" :banner="ocorrenciaBloqueante ? 'alert-danger' : 'alert-warning'" />

        <template v-for="(alerta, index) in alertas" >
          <AlertBanner v-if="alerta.mostrar" :key="index" :message="alerta.msg" :type="alerta.tipo" />
        </template>

        <template v-if="(componente === 'aba-atos' || ficha.status == 'PENDENTE') && ficha.textoLegado">
          <a @click.prevent="vizualizarTextoLegado(ficha)" title="Vizualizar Texto" href>
            <AlertBanner message="Indicador possui um texto importado!"/>
          </a>
        </template>

      </template>

    </template>
    <component v-if="!loading && aba" :is="componente" :ficha="ficha" :id="ficha.id" :preview="preview" :ativa="aba === 'sigef'" :unidades="componente === 'aba-unidades-mae' ? unidadesDaMae : undefined" @load="load"  @ficha-atualizada="atualizarFicha"/>
    <p v-if="!loading && !aba && $root.isAuditorOnly" class="text-muted text-center py-4">Nenhuma aba autorizada.</p>
    <template #footer v-if="permitirExcluir && aba == 'dados'">
      <v-button :run="excluir" :popover="true" position="dropupleft" class="btn btn-outline-danger ml-auto">Excluir</v-button>
    </template>
  </modal>

</template>

<script>

import AuditorBusiness from "@/business/AuditorBusiness.js";
import AuditoriaBusiness from "@/business/AuditoriaBusiness.js";
import FrontBusiness from "@/business/FrontBusiness";
import IndicadorBusiness from "@/business/indicadores/IndicadorBusiness";
import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness";
import EventBus from "@/commons/EventBus";
import AlertBanner from "@/components/alert/AlertBanner";
import AlertMessage from "@/components/alert/AlertConstMessage";
import AlertOcorrencia from "@/components/alert/AlertOcorrencia.vue";
import RegistrosPosteriores from "@/components/IndicadorGeneric/Detalhes/RegistrosPosteriores.vue";
import Anexos from "@/components/IndicadorReal/Detalhes/Anexos";
import Atos from "@/components/IndicadorReal/Detalhes/Atos";
import Dados from "@/components/IndicadorReal/Detalhes/Dados";
import ExProprietarios from "@/components/IndicadorReal/Detalhes/ExProprietarios";
import Historico from "@/components/IndicadorReal/Detalhes/Historico";
import Indisponibilidades from "@/components/IndicadorReal/Detalhes/Indisponibilidades";
import Ocorrencias from "@/components/IndicadorReal/Detalhes/Ocorrencias.vue";
import Protocolos from "@/components/IndicadorReal/Detalhes/Protocolos";
import Tabelionato from "@/components/IndicadorReal/Detalhes/Tabelionato";
import Resumo from "@/components/IndicadorReal/Detalhes/Resumo.vue";
import Sigef from "@/components/IndicadorReal/Detalhes/Sigef.vue";
import UnidadesDaMatriculaMae from "@/components/IndicadorReal/Detalhes/UnidadesDaMatriculaMae.vue";
import Versoes from "@/components/IndicadorReal/Detalhes/Versoes.vue";
import FormIndicadorReal from "@/components/IndicadorReal/Form/FormIndicadorReal.vue";
import ImprimirFicha from "@/components/Livros/ImprimirFicha.vue";
import Modal from "@/components/Modal";
import ModalOdinProcessamentoMatricula from "@/views/Odin/modais/ModalOdinProcessamentoMatricula.vue";
import OdinBusiness from "@/views/Odin/OdinBusiness";
import TextoLegado from "@/views/Protocolo/Atos/TextoLegado";
import OcorrenciaBusiness from "@/business/ocorrencia/OcorrenciaBusiness";
import ImportarIndicadorReal from "@/components/IndicadorReal/Detalhes/ImportarIndicadorReal.vue";

export default {

    name: "DetalhesIndicadorReal",
    components: {
      AlertOcorrencia,
      AlertIndisponibilidade: () => import("@/components/alert/AlertIndisponibilidade"),
      AlertBanner,
      Modal,
      "aba-dados" : Dados,
      "aba-versoes" : Versoes,
      "aba-resumo" : Resumo,
      "aba-unidades" : RegistrosPosteriores,
      "aba-unidades-mae" : UnidadesDaMatriculaMae,
      "aba-ex-proprietarios" : ExProprietarios,
      "aba-atos" : Atos,
      "aba-sigef" : Sigef,
      "aba-protocolos" : Protocolos,
      "aba-tabelionato" : Tabelionato,
      "aba-ocorrencias" : Ocorrencias,
      "aba-anexos" : Anexos,
      "aba-historico" : Historico,
      "aba-indisponibilidades" : Indisponibilidades
    },

    props: {
      id : String,
      preview: Object,
      abaInicial: String
    },

    modal: {
      width: 1200
    },

    async mounted(){
      await this.load();
      await this.possuiOcorrenciasBloqueantes();
      AuditoriaBusiness.auditarTela({id: this.id, entidade: 'INDICADOR_REAL', descricao: `Tela: Detalhes do Indicador` })
        .catch(e => null);

      EventBus.$on('ATOS-LOAD', this.load);
    },

    computed:{
      mostrarIa(){
        return this.$root.mostrarIA && this.$root.getPermission({id: 'PERMITIR_PROCESSAR_MATRICULAS'});
      },
      titulo(){
        return this.ficha?.livro ? FrontBusiness.nomearFicha(this.ficha) : '';
      },
      componente(){
        return `aba-${this.aba}`;
      },

      indicadorPossuiBloqueioSaec() {
        return this.ficha?.bloquearVisualizacaoSaec && ['MATRICULA'].includes(this.ficha.livro);
      },

      alertas() {
          return [
              // {mostrar: this.ficha.indisponibilidades?.length, msg: AlertMessage.indicadorPossuiIndisponibilidade(), tipo : 'alert-danger'},
              // {mostrar: this.ficha.ocorrenciasAtivas, msg: AlertMessage.indicadorPossuiOcorrencias(), tipo : 'alert-danger'},
              {mostrar: this.impressaoDesatualizada, msg: AlertMessage.impressaoDesatualizada(), tipo : 'alert-warning'},
              {mostrar: this.digitalizacaoDesatualizada, msg: AlertMessage.digitalizacaoDesatualizada(), tipo : 'alert-warning'},
              {mostrar: this.protocolosAtivos, msg: AlertMessage.indicadorPossuiProtocolos(), tipo : 'alert-warning'},
              {mostrar: this.indicadorPossuiBloqueioSaec, msg: AlertMessage.indicadorPossuiBloqueioSaec(), tipo : 'alert-warning'},
          ];
      },

      usuario() {
        return this.$root.usuarioLogado;
      },

      permitirImprimir(){
        return !this.$root.isAuditorOnly && !this.preview
          && (this.ficha.status != 'PENDENTE' || this.$root.config?.indicadorReal?.permitirRegistroPreMatricula)
      },

      isAuditor() {
        return this.$root.isAuditorOnly;
      },

      permitirExcluir(){
        return this.ficha.livro === 'TRANSCRICAO' || this.$root.getPermission({id: 'PERMITIR_EXCLUIR_INDICADOR_REAL'});
      },

      /* FIXME: Migrar para IndicadorBusiness.classStatus(). */
      classStatus() {
        if (this.statusExibido == 'ENCERRADA' || this.statusExibido == 'LAVRADO') {
          return 'badge-primary-soft';
        } else if (this.statusExibido == 'CANCELADA') {
          return 'badge-danger-soft';
        } else if (this.statusExibido == 'ANULADA') {
          return 'badge-danger-soft';
        } else if (this.statusExibido == 'INEXISTENTE') {
          return 'badge-secondary-soft';
        } else if (this.statusExibido == 'BLOQUEADA') {
          return 'badge-warning-soft';
        }
        return 'badge-success-soft'
      },
      statusExibido() {
        return IndicadorBusiness.getStatusExibido(this.ficha);
      },

      deveExibirBadgeStatus() {
        const isLivroNotas = this.ficha?.livro === 'LIVRO_NOTAS' || this.ficha?.livroNotas;
        const status = this.ficha?.status;
          if (isLivroNotas) {
          return status !== 'ABERTA';
        }
        
        return status !== 'ABERTA' && status !== 'LAVRADO';
      }
    },

    data() {

      return {
        ficha : {},
        aba : !this.$root.isAuditorOnly || this.$root.hasAuditorPermission('AUDITOR_ABA_DADOS_IR') ? 'dados' : null,
        protocolosAtivos: false,
        impressaoDesatualizada : false,
        digitalizacaoDesatualizada : false,
        indicadorValido: false,
        abas:[],
        unidadesDaMae: null,
        loading: true,
        ocorrenciaBloqueante: false
      }
    },

    methods:{
      showError(e) {
        FrontBusiness.showError('', e.message);
      },

      atualizarFicha(fichaAtualizada) {
        this.$set(this, 'ficha', fichaAtualizada);
      },

      async load(loading = true){
        this.loading = loading;
        if (!!this.preview) {
          this.ficha = this.preview
        } else {
          this.ficha = await IndicadorRealBusiness.getById(this.id);

          let protocolos = [];
          const auditor = this.$root.isAuditorOnly;

          await Promise.all([
            // await IndicadorRealBusiness.buscarAtosRegistrados(this.ficha.id).then(r => this.atos = r),
            !auditor ? IndicadorRealBusiness.buscarProtocolosAtivos(this.ficha.id).then(r => protocolos = r) : null,
            !auditor ? this.checarImpressao() : null,
            this.indicadorRealValidado()
          ]);

          this.protocolosAtivos = protocolos.length > 0;

        }

        let exibir = !this.$root.isAuditorOnly && !this.preview;
        let isPendente = this.ficha.status == 'PENDENTE';
        let permiteRegistroAto = this.$root.config?.indicadorReal?.permitirRegistroPreMatricula;
        let isRuralUrbano = this.ficha.categoria == 'RURAL' || this.ficha.categoria == 'URBANO';
        let configuracao = this.$root.config;

        let isAuditorOnly = this.$root.isAuditorOnly;
        let abaVisivel = (perm) => AuditorBusiness.abaVisivel(perm);
        let exibirAba = (perm) => AuditorBusiness.exibirAba(perm, this.preview);

        // Matrícula-mãe: a aba de unidades só nasce quando há unidade para mostrar. A aba
        // incondicional seria ruído em toda matrícula do acervo, porque a ficha comum não é mãe de
        // nada — e aba vazia ensina o conferente a não clicar naquela que tem conteúdo.
        //
        // Dois sinais, e basta um: a unidade que já virou ficha própria (a consulta inversa de
        // `listarUnidades`, a mesma da aba Registros Posteriores) e a unidade que a análise leu do
        // teor e gravou como referência de transmissão na ficha da mãe. O segundo sai de graça —
        // `referencias` já vem no getById —, e é ele que cobre o loteamento cujos lotes ainda não
        // foram abertos.
        //
        // A consulta é feita aqui, e não dentro da aba, porque a decisão de EXIBIR precisa dela
        // antes de a aba existir. A lista desce por prop, para a mesma pergunta não ser feita duas
        // vezes na abertura da mesma ficha.
        let ehMatriculaMae = false;
        this.$set(this, 'unidadesDaMae', null);
        if (exibir && !this.ficha.tipo && ['MATRICULA', 'TRANSCRICAO'].includes(this.ficha.livro)) {
          const unidades = await IndicadorRealBusiness.listarUnidades(this.ficha.id).catch(() => []) || [];
          this.$set(this, 'unidadesDaMae', unidades);
          // Os dois tipos de unidade: a que saiu da ficha e a que a ficha descreve e continua tendo
          // (o estoque, gravado desde 16/09/2026). Sem o segundo, a matrícula-mãe que só registrou
          // estoque teria as linhas no card "Referências" e nenhuma aba para lê-las.
          const lidasDoTeor = (this.ficha.referencias || [])
            .some(r => r && IndicadorRealBusiness.eReferenciaDeUnidade(r.tipo));
          ehMatriculaMae = unidades.length > 0 || lidasDoTeor;
        }

        this.abas = [
          {id: 'dados', nome: 'Dados', exibir: abaVisivel('AUDITOR_ABA_DADOS_IR'), title: 'Dados Principais'},
          {id: 'atos', nome: 'Atos Registrados', exibir: (!this.preview && (!isPendente || permiteRegistroAto)) && abaVisivel('AUDITOR_ABA_ATOS_REGISTRADOS_IR'), title: 'Atos Registrados'},
          {id: 'resumo', nome: 'Resumo', exibir: (exibir && configuracao.resumoIndicadorReal) && !isAuditorOnly},
          {id: 'sigef', nome: 'Georreferenciamento', exibir: exibirAba('AUDITOR_ABA_SIGEF_IR') && isRuralUrbano},
          {id: 'unidades', nome: 'Registros Posteriores', exibir: exibirAba('AUDITOR_ABA_REGISTROS_POSTERIORES_IR') && ['MATRICULA', 'TRANSCRICAO'].includes(this.ficha.livro)},
          {id: 'unidades-mae', nome: 'Unidades', exibir: ehMatriculaMae, title: 'Unidades geradas por esta matrícula'},
          {id: 'ex-proprietarios', nome: 'Ex-Proprietários', exibir: (!this.preview && (!isPendente || permiteRegistroAto)) && abaVisivel('AUDITOR_ABA_EX_PROPRIETARIOS_IR')},
          {id: 'protocolos', nome: 'Protocolos', exibir: exibirAba('AUDITOR_ABA_PROTOCOLOS_IR')},
          {id: 'tabelionato', nome: 'Tabelionato', exibir: exibir && ['MATRICULA', 'TRANSCRICAO'].includes(this.ficha.livro) && this.$root.atribuicaoAtiva('RI') && this.$root.atribuicaoAtiva('NOTAS'), title: 'Atos do Tabelionato vinculados à matrícula'},
          {id: 'indisponibilidades', nome: 'CNIB', exibir: exibirAba('AUDITOR_ABA_CNIB_IR') && !isPendente},
          {id: 'ocorrencias', nome: 'Ocorrências', exibir: exibirAba('AUDITOR_ABA_OCORRENCIAS_IR')},
          // {id: 'anexos', nome: 'Anexos', exibir: exibir, title: 'Documentação & Anexos'}
        ];

        if (this.abaInicial) {
          this.$set(this, 'aba', this.abaInicial);
        }

        if (this.$root.isAuditorOnly) {
          const abasVisiveis = this.abas.filter(a => a.exibir);
          const abaAtualValida = abasVisiveis.some(a => a.id === this.aba);
          if (!abaAtualValida) {
            this.$set(this, 'aba', abasVisiveis.length > 0 ? abasVisiveis[0].id : null);
          }
        }

        this.$set(this, 'loading', false);

      },

      async possuiOcorrenciasBloqueantes(){
        let ocorrenciasIndicadorReal = await OcorrenciaBusiness.listarPorIndicadorReal(this.ficha.id);
        for (let i = 0; i < ocorrenciasIndicadorReal.length; i++) {
          if (ocorrenciasIndicadorReal[i].ocorrencia_bloqueante === "true") {
            this.ocorrenciaBloqueante = true;
          }
        }
      },

      async checarImpressao(){
        this.digitalizacaoDesatualizada = await IndicadorRealBusiness.digitalizacaoDesatualizada(this.id);
        this.impressaoDesatualizada = await IndicadorRealBusiness.impressaoDesatualizada(this.id);
      },

      async odinMatricula(ficha){

        // O motor novo (ITN) é o destino deste ícone. Quem decide é o backend, e são dois os desvios
        // para o motor antigo: a rampa (matrícula que já tem ato analisado por ele continua nele,
        // para não partir conferência em andamento) e a configuração `motorAntigoMatriculaAtivo`,
        // do cartório que pediu para continuar no fluxo antigo.
        //
        // Falha na consulta cai no motor antigo. É conservador de propósito: sem saber se a ficha
        // tem análise legada, mandá-la para a tela nova é justamente o que partiria a conferência.
        const decisao = await OdinBusiness.getMotorAnaliseMatricula(ficha.id).catch(() => null);

        if(decisao?.motor === 'ITN'){
          const route = this.$router.resolve({name: 'odin-matricula-itn-odin', params: {indicadorRealId: ficha.id}});
          window.open(route.href, '_blank');
          return;
        }

        await FrontBusiness.openModal(ModalOdinProcessamentoMatricula, {indicadorRealId: ficha.id, textoLegado: !!ficha.textoLegado});
        // await FrontBusiness.sleep(500);
        // await this.load();
      },

      async editarIndicador(ficha) {
        let result = await FrontBusiness.openModal(FormIndicadorReal, {id: ficha.id, livro: ficha.livro});
        if(result){
          this.$set(this, 'ficha', {});
          await this.load();
        }
      },

      async importarIndicador(ficha) {
        let result = await FrontBusiness.openModal(ImportarIndicadorReal, {ficha: ficha});
        if(result){
          this.$set(this, 'ficha', {});
          await this.load();
        }
      },

      async imprimir(ficha){
        FrontBusiness.openModal(ImprimirFicha, {id: ficha.id, tipo: ficha.livro, codigo: ficha.codigo});
        this.aba = 'dados';
      },

      async vizualizarTextoLegado(ficha){
        let retorno = await FrontBusiness.openModal(TextoLegado, {ficha: ficha, tipo: "INDICADOR_REAL"});
        if (retorno) {
          this.ficha = retorno;
        }
      },

      async indicadorRealValidado(){
        this.indicadorValido = await IndicadorRealBusiness.indicadorRealValidado(this.ficha.id);
      },

      async excluir(){
        if (this.permitirExcluir) {
          let retorno = await IndicadorRealBusiness.delete(this.ficha.id).catch(this.showError);
          if (retorno) {
            FrontBusiness.closeModal();
          }
        }
      },
      getTipoEntidade(ficha){
        return IndicadorBusiness.getTipoEntidade(ficha);
      },

    }

  }
</script>
